import Seo from "@/components/Seo";
import { usePublicData } from "@/lib/publicData";
import { PageHero, Container, Reveal, CtaBand } from "@/components/public/parts";
import { ExternalLink, Globe } from "lucide-react";

export default function Resources() {
  const data = usePublicData();
  const resources = data?.resources || [];
  return (
    <>
      <Seo title="Resources | Love For Mankind" description="Helpful external resources for families, individuals and case managers working with Love For Mankind in Ohio." path="/resources" />
      <PageHero eyebrow="Helpful Information" title="Resources" sub="Trusted external organizations and information." breadcrumbs={[{ label: "Home", to: "/" }, { label: "Resources" }]} />
      <Container className="py-16 lg:py-24">
        <div className="grid sm:grid-cols-2 gap-6">
          {resources.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.05}>
              <a href={r.url} target="_blank" rel="noopener noreferrer" data-testid="resource-item"
                className="group flex gap-5 rounded-2xl border border-border bg-card p-6 hover:border-primary/40 transition-colors h-full">
                <div className="w-12 h-12 rounded-xl bg-secondary flex items-center justify-center shrink-0 group-hover:bg-primary transition-colors"><Globe className="w-6 h-6 text-primary group-hover:text-primary-foreground transition-colors" /></div>
                <div className="min-w-0">
                  <h2 className="font-heading text-xl font-semibold flex items-center gap-1.5">{r.name}<ExternalLink className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors" /></h2>
                  <p className="text-[15px] text-muted-foreground mt-2 leading-[1.6]">{r.description}</p>
                  <span className="text-sm text-primary font-medium mt-2 inline-block break-all">{r.url.replace("https://", "")}</span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-8">These are external resources. Links open in a new tab and are not affiliated with Love For Mankind.</p>
      </Container>
      <CtaBand />
    </>
  );
}
